var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34722 10.4583L7.77778 13.375L11.1806 9L15.5556 14.8333H1.94444M17.5 15.8056V2.19444C17.5 1.11528 16.625 0.25 15.5556 0.25H1.94444C0.875 0.25 0 1.125 0 2.19444V15.8056C0 16.875 0.875 17.75 1.94444 17.75H15.5556C16.625 17.75 17.5 16.875 17.5 15.8056Z",
    fill: "#01AD25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.735459d0bd445dd0378eb868b20cb53e.svg";
export { ForwardRef as ReactComponent };